"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _default = exports.default = {
  common: {
    query: 'Search',
    reset: 'Reset',
    title: 'Title',
    add: 'Add',
    export: 'Expert',
    exports: 'Batch Expert',
    save: 'Save',
    updates: 'Batch Update',
    fileSearch: 'Search',
    saveAndAdd: 'Save & Add',
    submit: 'Submit',
    cancel: 'Cancel',
    goBack: 'Return',
    operation: 'Operation',
    edit: 'Edit',
    detail: 'Details',
    moduleEdit: 'Module Question Config',
    test: 'Test',
    startTest: 'Start',
    delete: 'Delete',
    suggestStart: 'Start'
  },
  selectMessage: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    addQuestions: 'Please add test questions first',
    feedbackDate: 'Feedback Date',
    addCompany: 'Please add the applicable company before submitting it.',
    read: 'Read',
    associatedQuestionBank: 'Associated Question Bank',
    requiredFlag: 'Required Question',
    singleMaintenanceQuestions: 'Maintenance Questions',
    maintenanceQuestions: 'Maintenance Questions',
    answer: 'Answer',
    task: 'Task',
    feedback: 'Feedback',
    start: 'Start Test',
    examination: 'Examination',
    needExam: 'Need Exam',
    failedTopic: 'Getting question failed.',
    submitFailure: 'Submit failed',
    submitSuccessfully: 'Submit successfully',
    repeatNumber: 'Standard duplicate',
    deleteMsgTip: 'The vesion can not be deleted because of including files. ',
    mustBeFilled: "Position/Rank must be existed",
    oneCorrectAnswer: "Must be one answer",
    eachMustFilled: "Content can not be empty",
    questionsUnanswered: 'Are you sure to submit before finishing the test?',
    confirmSubmission: 'Are you sure to submit?',
    canceled: 'Cancelled',
    common: 'Total',
    questions: 'Questions',
    alreadyAnswered: 'Answered',
    unanswered: 'Un-answered',
    haveNotStarted: 'Un-start',
    underway: 'Processing',
    completed: 'Completed',
    hour: "H",
    minutes: "M",
    seconds: "S",
    totalNum: 'Total',
    learnedNum: 'Learned',
    feedbackNum: 'Feedback',
    questionModule: 'Module',
    shipName: 'Ship',
    examAdress: 'Location',
    onShip: 'On-boat',
    onVacation: 'Leave',
    onOffice: 'Office',
    moduleInvolved: 'Module',
    examType: 'Test Type',
    questionType: 'Question Type',
    judge: 'True or False ',
    company: 'Company',
    version: 'Version',
    status: 'Status',
    draft: 'Draft',
    effectiveDate: 'Effective Date',
    inApproval: 'Approving',
    approvalCompleted: 'Approved',
    effective: 'Valid',
    invalid: 'Invalid',
    notInForce: 'Not Effective',
    selectMsg: 'Position/Rank must be existed',
    selectMsg1: 'Rank can not be empty',
    updateFile: 'Update File',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    look: 'Details',
    download: 'Download',
    getFail: 'Getting data failed',
    updates: 'Batch Update',
    message: 'Please select',
    questionMsg: 'Getting data failed please retry',
    deleteMsg: 'Are you sure to delete the selected item?',
    cancelMsg: 'Are you sure to cancel the selected item?',
    updateStatus: 'Are you sure to edit the selected state?',
    isExam: 'Status',
    examDate: 'Test Date',
    tips: 'Info.',
    confirm: 'Ok',
    cancel: 'Cancel',
    deleteSuccess: 'Operate successfully',
    deleteFail: 'Operate failed',
    cancelDelete: 'Cancel operation',
    StandardManagement: 'Standard',
    saveSuccess: 'Save successfully',
    saveFail: 'Save failed',
    selectDate: 'Select date',
    uploadFail: 'Upload file error ,please retry',
    startDate: 'Effective Date(From)',
    endDate: 'Effective Date(To)',
    operation: 'Operate',
    fileType: 'File Type',
    ApplicablePosition: 'Position',
    shipPosition: 'Rank',
    questionTitle: 'Question',
    questionTitleMsg: 'please enter',
    relationChapter: 'DOC. Section',
    relationChapterMsg: 'please enter',
    publicMsg: 'Please input',
    yes: 'Y',
    no: 'N',
    OptionsAndAnswerSettings: 'Answer Config',
    option: 'Option',
    AnswerSetting: 'Answer',
    OptionContent: 'Content',
    moduleEdit: 'Module Question Config',
    examPost: 'Position/Rank',
    test: 'Test',
    startTest: 'Start',
    examNo: 'Task No.',
    taskName: 'Task Name',
    userName: 'Person Name',
    JobNumber: 'Employee ID',
    taskNo: 'Task No.',
    tempsave: 'Temp. Save',
    Assignor: 'Assigner',
    AssignDate: 'Assigned Date',
    CompletionDate: 'Learned Deadline',
    FeedbackResults: 'If feedback',
    FeedbackResult: 'Implementation',
    taskRequirements: 'Task Requirement',
    LearningRequirements: 'Learning Requirement',
    FeedbackContent: 'Feedback Content',
    FeedbackTime: 'Feedback Date',
    Enclosure: 'Attachment',
    EnclosurePDF: 'Attachment(PDF)',
    Enclosures: 'Attachment',
    UploadFile: 'Upload Attachment',
    FinishReading: 'Done',
    Close: 'Close',
    saveDetail: 'Operate Successfully'
  }, "saveFail", 'Operate Failed'), "feedbackAssignRemark", 'Implementation Requirement'), "feedbackRelustRemark", 'Implementation Result'), "tooltips", 'Require content can not be empty.'), "learnUserName", 'Implementer'), "learnUserJob", 'Position/Rank'), "learnUserDepartment", 'Department/Ship'),
  examQuestion: {
    index: {
      title: 'Examination',
      item: 'Exam Database',
      query: {
        itemName: 'Item Name'
      },
      table: {
        department: 'Department',
        tableNo: '',
        sysPostId: 'Position',
        examMouduleId: 'Module',
        relationFileChapter: 'DOC. Section',
        questionType: 'Question Type',
        questionTitle: 'Question',
        numberOfModuleQuestions: 'Question Quantity for Module',
        number: 'Quantity'
      },
      filterList: {
        status: 'status',
        effective: 'Valid',
        invalid: 'Invalid'
      }
    },
    editQuestion: {
      form: {
        title: 'Exam Database',
        questionType: 'Question Type',
        sysPostId: 'Position/Rank',
        examMouduleId: 'Module',
        relationFileChapter: 'DOC. Section',
        examType: 'Test Type',
        requiredFlag: 'Required Question',
        effectFlag: 'Status',
        questionProbablity: 'Question weight ',
        temporaryFlag: 'Temp. Test',
        questionTitle: 'Question',
        comfirmMsg: 'Ok'
      }
    }
  },
  examAssign: {
    index: {
      exam: 'Examination',
      title: 'Examination',
      item: 'Exam Distribution',
      query: {
        itemName: 'Item Name'
      },
      table: {
        examTaskNo: 'Task No.',
        examTaskName: 'Task Name',
        questionType: 'Test Type',
        sysPostId: 'Position/Rank',
        principalOrgCode: 'Ship',
        startTime: 'Start Date',
        endTime: 'End Date',
        testSummer: 'Test Summary',
        testStatus: 'Test status',
        sponsor: 'Started by'
      }
    },
    editAssign: {
      form: {
        title: 'Add Test Task',
        examTaskNo: 'Task No.',
        questionType: 'Test Type',
        examTaskNameCn: 'Task Name',
        startTime: 'Start Date',
        endTime: 'End Date',
        examPostId: 'Position',
        sysPostId: 'Rank',
        shorePostId: 'Position',
        principalOrgCode: 'Ship',
        examTaskRemark: 'Requirement'
      }
    }
  },
  examTest: {
    index: {
      title: 'Examination',
      item: 'Examination',
      query: {
        itemName: 'Item Name'
      },
      table: {
        examTaskNo: 'Task No.',
        examTaskNameCn: 'Task Name',
        sysUserNameCn: 'Name',
        sysUserNo: 'Employee ID',
        sysPostId: 'Position/Rank',
        lastTestTime: 'Test Date',
        testCore: 'Test Score',
        locationNameCn: 'Location',
        testStatus: 'Status',
        shipName: 'Ship',
        marksPercent: '%',
        average: 'Average Score'
      }
    },
    testPaper: {
      form: {
        title: 'Test Info.',
        userName: 'Name',
        userNo: 'Employee ID',
        startTime: 'Test Date',
        reviewScore: 'Test Score',
        single: 'One-Choice',
        multiple: 'Multiple-Choice',
        judgment: 'True or False',
        standardAnswer: 'Correct Answer',
        userAnswer: 'Your Answer',
        testStatus: 'Status',
        paper: 'Test Paper',
        remainTime: 'Remaining time'
      }
    },
    editExamTest: {
      form: {
        title: 'Test Question',
        examTaskNo: 'Task No.',
        examTaskNameCn: 'Task Name',
        sysUserNameCn: 'Person Name',
        sysUserNo: 'Employee ID',
        sysPostId: 'Position/Rank',
        sysRole: 'Role',
        lastTestTime: 'Test Date',
        testCore: 'Test Score',
        locationNameCn: 'Location',
        testStatus: 'Status',
        questionType: 'Test Type'
      }
    }
  },
  examSummary: {
    index: {
      title: 'Examination',
      item: 'Exam Statistic',
      query: {
        itemName: 'Test Search'
      },
      table: {
        userName: 'Name',
        userNo: 'Employee ID',
        sysUserNameCn: 'Position/Rank',
        principalOrgCode: 'Ship',
        questionType: 'Test Type',
        startTime: 'Test Date',
        locationName: 'Test location',
        longtime: 'Test time',
        testCore: 'Test Score',
        testStatus: 'Task Name',
        examTaskNo: 'Task No.'
      }
    }
  }
};